import React, { useEffect, useState } from 'react';
import {
  VertContainer,
  VertTypography,
  VertSelect,
  VertInput,
  VertRadio,
  VertCheckbox,
  VertButton,
  Upload,
  Row,
  Col,
  VertDatePicker,
  Form,
  Typography,
  message,
  Spin,
  VertBreadcrumb,
  VertIcon,
  VertTooltip,
} from '@vertem-core/vertice-ds';
import {
  UserOutlined,
  CreditCardOutlined,
  EnvironmentOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  CloseOutlined,
  RightOutlined,
} from '@ant-design/icons';
import { v4 as uuidv4 } from 'uuid';
import * as yup from 'yup';
import '../../Assets/styles/default/pages/newSolicitationSpot/newSolicitationSpot.less';
import NewSolicitationModal from './modal/newSolititationModal';
import { useDispatch, useSelector } from 'react-redux';
import { cnpj, cpf } from 'cpf-cnpj-validator';
import ValuePriceForPoint from './components/ValuePriceForPoint';
import redemptionsApiClient from 'Services/Apis/Spot/redemptionsClient';
import dayjs from 'dayjs';
import MaskedInput from './components/InputMask';
import SpotltmClient from 'Services/Apis/Spot/ltmApiService';
import { isEmpty } from 'lodash';
import TitleForm from './components/TitleForm/TitleForm';
import { useNavigate } from 'react-router-dom';
import UnauthorizedSpot from './components/UnauthorizedSpot/UnauthorizedSpot';
import { calculatePriceForPoint } from 'Utils/calculatePriceForPoint';
import { convertPoints } from 'Utils/maskFormat';
import useParticipantSubSegment from 'Hooks/useParticipantSubSegment';
import {
  loadWallet,
  loadUserInfos,
  setOpenModal,
  setValorTotalProdutos,
  setResetDataParticipant,
  calculateShipping,
} from 'redux/Reducers/Spot/spotNewSolicitationSlice';
import { format, parse } from 'date-fns';
import { LuTruck } from 'react-icons/lu';
import { getGroups } from 'Utils/validateHierarchy';
import { useMediaQuery } from 'react-responsive';
import OpenParticipantCatalogModal from './modal/OpenParticipantCatalogModal';
import FinishSimulationModal from './modal/FinishSimulationModal';
import TableProductHierarchy from './components/TableProduct/tableProductHierarchy';
import { useHierarchyProductsLocalStorageContext } from 'Context/HierarchyLocalStorageContext';
import { useSimulationLocalStorageContext } from 'Context/SimulationLocalSotrageContext';
import { handleAddressNumberOutput } from 'Utils/commons/address';
import SpotTableAndProducts from 'components/Spot/SpotTable';

const NewSolicitation = () => {
  const dispatch = useDispatch();
  const {
    saldoParticipante,
    subSegmento,
    loading,
    loadingDataUserInfos,
    walletParticipant,
    dataParticipant,

    valorTotalProdutos,
    hierarchyShipping,
  } = useSelector((state) => state.SpotNewSolicitation);
  const [form] = Form.useForm();
  const showEnderecoFaturamentoWatch = Form.useWatch(
    'showEnderecoFaturamento',
    form
  );
  const navigate = useNavigate();
  const tipoSolicitacaoWatch = Form.useWatch('tipoSolicitacao', form);
  const cepWatch = Form.useWatch('cep', form);

  const participanteWatch = Form.useWatch('participante', form);
  const fileList = Form.useWatch('fileList', form);

  const [cotacaoPremmiar, setCotacaoPremmiar] = useState(true);
  const [isRequiredCategories, setIsRequiredCategories] = useState(false);
  const [novoFornecedor, setNovoFornecedor] = useState(false);
  const [fornecedorPreferenciaWatch, setFornecedorPreferenciaWatch] =
    useState(0);
  const [buscaFornecedorValue, setBuscaFornecedorWatch] = useState('');
  const [enderecoSelecionadoWatch, setEnderecoSelecionadoWatch] =
    useState(false);
  const [products, setProducts] = useState([]);
  const [dataSearchFornecedor, setDataSearchFornecedor] = useState([]);
  const [quoteUrl, setQuoteUrl] = useState(null);
  const [insufficientPoints, setInsufficientPoints] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [loadingCep, setLoadingCep] = useState(false);
  const [loadingSubEnderecoEntregaCep, setLoadingSubEnderecoEntregaCep] =
    useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [tableProductIsEmpty, setTableProductIsEmpty] = useState(false);
  const [botaoValido, setBotaoValido] = useState(false);
  const [validateGroupSpot, setValidateGroupSpot] = useState(false);
  const [dataFornecedor, setDataFornecedor] = useState([]);
  const [dataBuscaFornecedor, setDataBuscaFornecedor] = useState({
    cnpj: '',
    nomeEmpresa: '',
  });
  const [productsTotalShippingRate, setProductsTotalShippingRate] = useState(0);
  const [isOpenHierarchyModal, setIsOpenHierarchyModal] = useState(false);
  const [isOpenFinishSimulationModal, setIsOpenFinishSimulationModal] =
    useState(false);
  const [access, setAccess] = useState(false);
  const {
    isPMO,
    isLead,
    isManager,
    isFocalizationAnalyst,
    getRedemptionSpotGroups,
  } = useParticipantSubSegment();
  const userProfile = useSelector((state) => state.oidc.user.profile);
  const userInfos = useSelector(({ oidc: data }) => data);
  const mediaQuery = useMediaQuery({ query: '(max-width: 768px)' });

  const { hierarchyProductsLocalStorageValue, setHierarchyLocalStorageValue } =
    useHierarchyProductsLocalStorageContext();
  const { simulationLocalStorageValue, setSimulationLocalStorageValue } =
    useSimulationLocalStorageContext();

  const watchLocalStorage = () => {
    window.addEventListener('storage', (evento) => {
      if (evento.key === 'Premmiar@:products') {
        const newValue = JSON.parse(evento.newValue);
        setHierarchyLocalStorageValue({ products: newValue });
      }
      if (evento.key === 'Premmiar@simulation') {
        const newValue = JSON.parse(evento.newValue);
        setSimulationLocalStorageValue(newValue);
      }
    });
  };

  watchLocalStorage();

  const {
    user: { profile, access_token },
  } = userInfos;
  const username = profile.username || profile['custom:login'];

  const config = {
    campaignId: userProfile['custom:campaign_id'],
    catalogId: userProfile['custom:catalog_id'],
    participantId: userProfile['custom:participant_id'],
    Authorization: `Bearer ${access_token}`,
    username: username,
  };

  const numeroEndereco = Form.useWatch('numero', form);
  const subEnderecoEntregaNumero = Form.useWatch(
    'subEnderecoEntregaNumero',
    form
  );

  const validGroup = getRedemptionSpotGroups();
  const schema = yup.object().shape({
    tipoSolicitacao:
      tipoSolicitacaoWatch?.value === '1'
        ? yup.object().shape({
            value: yup.string().required('Tipo de Solicitação é obrigatório'),
            label: yup.string().required('Tipo de Solicitação é obrigatório'),
          })
        : yup.string().required('Tipo de Solicitação é obrigatório'),
    nome: yup
      .string()
      .required('Digite nome e sobrenome.')
      .min(1, 'Mínimo 1 caractere.')
      .max(150, 'Máximo 150 caracteres.'),

    cpf: yup
      .string()
      .required('Digite o CPF')
      .test('valida-cpf', 'CPF inválido', (value) => {
        return cpf.isValid(value);
      }),
    razaoSocial: yup.string().required('Razão Social é obrigatório'),
    cnpj: yup
      .string()
      .required('CNPJ é obrigatório')
      .test('valida-cnpj', 'Digite um CNPJ válido', (value) => {
        return cnpj.isValid(value);
      }),
    inscricaoEstadual: yup
      .string()
      .required('Inscrição Estadual é obrigatório'),

    ddd: yup
      .string()
      .required('DDD é obrigatório')
      .matches(/^[0-9]*$/, 'Somente números')
      .length(2, 'O DDD deve ter 2 dígitos'),
    celular: yup
      .string()
      .required('Celular é obrigatório')
      .min(8, 'Mínimo 8 dígitos')
      .matches(/^[0-9]*$/, 'Digite um telefone válido')
      .length(9, 'O celular deve ter 9 dígitos'),
    dataNascimento: yup.string().required('Data de Nascimento é obrigatório'),

    participante:
      tipoSolicitacaoWatch?.value === '1'
        ? yup.object().shape({
            value: yup.string().required('Participante é obrigatório'),
            label: yup.string().required('Participante é obrigatório'),
          })
        : yup.string().required('Participante é obrigatório'),
    email: yup
      .string()
      .email('Digite um e-mail válido ou deixe em branco')
      .max(150, 'Máximo 150 caracteres')
      .matches(
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
        'E-mail inválido'
      ),

    cep: yup
      .string()
      .required('CEP é obrigatório')
      .matches(/^[0-9]*$/, 'Somente números')
      .length(8, 'O CEP deve ter 8 dígitos'),
    rua: yup.string().required('Rua é obrigatório'),
    numero: yup
      .string()
      .required('Número é obrigatório')
      .matches(/^(S\/N|\d+)$/, 'Somente números ou S/N'),
    complemento: yup.string().nullable(),
    bairro: yup.string().required('Bairro é obrigatório'),
    estado: yup.string().required('Estado é obrigatório'),
    cidade: yup.string().required('Cidade é obrigatório'),

    subEnderecoEntregaCep: yup
      .string()
      .required('CEP é obrigatório')
      .matches(/^[0-9]*$/, 'Somente números')
      .length(8, 'O CEP deve ter 8 dígitos'),
    subEnderecoEntregaRua: yup.string().required('Rua é obrigatório'),
    subEnderecoEntregaComplemento: yup.string().nullable(),
    subEnderecoEntregaBairro: yup.string().required('Bairro é obrigatório'),
    subEnderecoEntregaNumero: yup
      .string()
      .required('Número é obrigatório')
      .matches(/^(S\/N|\d+)$/, 'Somente números ou S/N'),
    subEnderecoEntregaEstado: yup.string().required('Estado é obrigatório'),
    subEnderecoEntregaCidade: yup.string().required('Cidade é obrigatório'),
    nomeFornecedor: yup
      .string()
      .required('Nome do Fornecedor é obrigatório')
      .min(1, 'Mínimo 1 caractere.')
      .max(150, 'Máximo 150 caracteres.'),

    cnpjFornecedor: yup
      .string()
      .required('CNPJ é obrigatório')
      .test('valida-cnpj', 'Digite um CNPJ válido', (value) => {
        return cnpj.isValid(value);
      }),
  });

  useEffect(() => {
    validateAccess(true);

    if (!isPMO && !validGroup && !isManager) {
      setAccess(true);
    }

    if (!isPMO && !isManager && !isFocalizationAnalyst && validGroup) {
      form.setFieldValue('tipoSolicitacao', {
        value: '1',
        label: 'Spot',
      });
    }

    if (isFocalizationAnalyst) {
      form.setFieldValue('tipoSolicitacao', '3');
    }
  }, []);

  const optionsRedemption = () => {
    const options = [];
    const Spot = { value: '2', label: 'Spot' };
    const Hierarchy = { value: '3', label: 'Hierarquia' };

    if (isPMO || isLead || validGroup) options.push(Spot);

    if (isPMO || isLead || isManager) options.push(Hierarchy);

    if (isFocalizationAnalyst) {
      const spotIndex = options.findIndex((option) => option.value === '2');
      if (spotIndex !== -1) {
        options.splice(spotIndex, 1);
      }
    }

    return options;
  };

  const validateAccess = (redirect = false) => {
    let isValid = false;

    if (isPMO || isLead || isManager) {
      isValid = true;
    } else {
      isValid = validGroup;
    }

    if (!isValid && redirect) {
      return navigate('/');
    } else {
      return isValid;
    }
  };

  const reduceValuesOfProducts = (arrayDeProdutos) => {
    let total = 0;
    if (arrayDeProdutos && arrayDeProdutos?.length) {
      for (const produto of arrayDeProdutos) {
        const unitPrice = parseFloat(produto.unitPrice);
        const quantity = parseInt(produto.quantity);

        if (!isNaN(unitPrice) && !isNaN(quantity)) {
          total += unitPrice * quantity;
        }
      }

      return total;
    }
    return 0;
  };

  useEffect(() => {
    if (
      (products && products.length > 0) ||
      (hierarchyProductsLocalStorageValue.products &&
        hierarchyProductsLocalStorageValue?.products?.length > 0)
    ) {
      let total = 0;
      if (tipoSolicitacaoWatch != 3) {
        total = products.reduce((acc, product) => {
          return acc + product.valor * product.quantidade;
        }, 0);
      } else {
        total = reduceValuesOfProducts(
          hierarchyProductsLocalStorageValue?.products
        );
      }
      dispatch(setValorTotalProdutos(total));
      setBotaoValido(true);
      setTableProductIsEmpty(false);
    } else {
      dispatch(setValorTotalProdutos(0));
    }
  }, [
    products,
    tipoSolicitacaoWatch,
    hierarchyProductsLocalStorageValue.products,
  ]);

  useEffect(() => {
    let cepNumber = cepWatch?.replace(/[^0-9]/g, '');

    if (
      tipoSolicitacaoWatch == 3 &&
      hierarchyProductsLocalStorageValue?.products?.length &&
      cepNumber?.length === 8
    ) {
      dispatch(
        calculateShipping({
          products: hierarchyProductsLocalStorageValue?.products?.map(
            (item) => ({
              sku: item.sku,
              vendorId: item.vendorId.toString(),
              qty: Number(item.quantity),
            })
          ),
          zipCode: cepNumber,
        })
      );
    }
  }, [hierarchyProductsLocalStorageValue, cepWatch]);

  useEffect(() => {
    const calculateAndSetBotaoValido = async () => {
      const valorTotalEmPontos =
        tipoSolicitacaoWatch == 3
          ? reduceValuesOfProducts(
              hierarchyProductsLocalStorageValue?.products
            ) + hierarchyShipping.total
          : await calculatePriceForPoint(valorTotalProdutos, config);

      if (saldoParticipante < valorTotalEmPontos) {
        setBotaoValido(false);
        setInsufficientPoints(true);
      } else {
        setBotaoValido(true);
        setInsufficientPoints(false);
      }
    };

    calculateAndSetBotaoValido();
  }, [
    saldoParticipante,
    valorTotalProdutos,
    tipoSolicitacaoWatch,
    hierarchyShipping.total,
    hierarchyProductsLocalStorageValue.products.reduce((acc, product) => {
      return acc + product.quantity;
    }, 0),
  ]);

  useEffect(() => {
    const hasCategoriesInProduct = products.every(
      (product) => product.categoryId && product.subCategoryId
    );

    if (!cotacaoPremmiar && !hasCategoriesInProduct) {
      setIsRequiredCategories(true);
      return;
    }
    setIsRequiredCategories(false);
  }, [cotacaoPremmiar, products]);

  useEffect(() => {
    if (novoFornecedor && !cotacaoPremmiar) {
      setNovoFornecedor(false);
      form.resetFields(['nomeFornecedor', 'cnpjFornecedor', 'buscaFornecedor']);
      setDataBuscaFornecedor({
        cnpj: '',
        nomeEmpresa: '',
      });
    }
  }, [novoFornecedor, cotacaoPremmiar]);

  useEffect(() => {
    if (!getGroups(subSegmento, Number(tipoSolicitacaoWatch))) {
      setValidateGroupSpot(true);
      return;
    }
    setValidateGroupSpot(false);
  }, [subSegmento, tipoSolicitacaoWatch]);

  const openModalProduct = () => {
    dispatch(setOpenModal(true));
  };

  useEffect(() => {
    if (isManager || isPMO) {
      dispatch(loadWallet(config));
    }

    if (tipoSolicitacaoWatch?.value === '1') {
      findParticipants({
        value: config.username,
        label: 'Usuário',
      });
    }
    if (tipoSolicitacaoWatch === '3') {
      dispatch(
        loadUserInfos({
          username: participanteWatch,
          headers: config,
        })
      );
    }
  }, [
    isManager,
    isPMO,
    tipoSolicitacaoWatch?.value,
    tipoSolicitacaoWatch,
    participanteWatch,
  ]);

  const findParticipants = async (e) => {
    form.setFieldValue('participante', e);

    dispatch(
      loadUserInfos({
        username: e.value,
        headers: config,
      })
    );
  };

  const fetchCep = async (valueCep, name) => {
    const cepRegex = /^[0-9]{8}$/;
    if (!cepRegex.test(valueCep)) {
      return;
    }
    name === 'cep'
      ? setLoadingCep(true)
      : setLoadingSubEnderecoEntregaCep(true);

    try {
      const response = await SpotltmClient.get(
        `/cloudloyalty/v1/addresses/${valueCep}`,
        {
          headers: config,
        }
      );

      name === 'cep'
        ? setLoadingCep(false)
        : setLoadingSubEnderecoEntregaCep(false);
      if (name === 'cep') {
        form.setFieldsValue({
          rua: response.data.street,
          bairro: response.data.district,
          cidade: response.data.city,
          estado: response.data.state,
        });
      } else {
        form.setFieldsValue({
          subEnderecoEntregaRua: response.data.street,
          subEnderecoEntregaBairro: response.data.district,
          subEnderecoEntregaCidade: response.data.city,
          subEnderecoEntregaEstado: response.data.state,
        });
      }
    } catch (error) {
      if (error.response && error.response.status === 422) {
        form.setFields([
          {
            name: name,
            errors: ['CEP não encontrado'],
          },
        ]);
      } else {
        form.setFields([
          {
            name: name,
            errors: ['Ocorreu um erro ao buscar o CEP'],
          },
        ]);
        console.info('Ocorreu um erro ao buscar o CEP:', error);
      }
    } finally {
      name === 'cep'
        ? setLoadingCep(false)
        : setLoadingSubEnderecoEntregaCep(false);
    }
  };

  const valuesParticipantName = walletParticipant?.map((item) => {
    return {
      value: item.cpfCnpj,
      label: cpf.isValid(item.cpfCnpj)
        ? `${cpf.format(item.cpfCnpj)} - ${item.name}`
        : `${cnpj.format(item.cpfCnpj)} - ${item.name}`,
      name: item.name,
    };
  });

  const fetchFornecedor = async (value) => {
    const { data } = await redemptionsApiClient.get(
      `Supplier?filter=${value}`,
      {
        headers: config,
      }
    );

    setDataFornecedor(data);

    if (data) {
      let dataFornecedor;

      const hasLetters = /[a-zA-Z]/.test(value);

      if (hasLetters) {
        dataFornecedor = data.map((item) => {
          let companyName = item.companyName;
          if (mediaQuery) {
            companyName =
              item.companyName.length > 20
                ? item.companyName.substring(0, 20) + '...'
                : item.companyName;
          }
          return {
            value: item.companyName,
            label: `${companyName} - ${cnpj.format(item.document)}`,
          };
        });
      } else {
        dataFornecedor = data.map((item) => {
          let companyName = item.companyName;
          if (mediaQuery) {
            companyName =
              item.companyName.length > 20
                ? item.companyName.substring(0, 20) + '...'
                : item.companyName;
          }
          return {
            value: item.document,
            label: `${companyName} - ${cnpj.format(item.document)}`,
          };
        });
      }

      setDataSearchFornecedor(dataFornecedor);
    }
  };

  const handleParticipantChange = (value) => {
    form.resetFields([
      'nome',
      'cpf',
      'dataNascimento',
      'ddd',
      'celular',
      'email',
    ]);

    dispatch(
      loadUserInfos({
        username: value,
        headers: config,
      })
    );
  };

  function hasNullOrUndefinedValues(obj) {
    for (const key in obj) {
      if (obj[key] === null || obj[key] === undefined) {
        return true;
      }
    }

    if (
      obj.district == 'Nao Informado' ||
      obj.street == 'Nao Informado' ||
      obj.zipCode == '00000000' ||
      obj.zipCode == ''
    ) {
      return true;
    }
    return false;
  }
  useEffect(() => {
    let addressNumber = handleAddressNumberOutput(dataParticipant?.number);

    if (
      dataParticipant &&
      dataParticipant.celular &&
      dataParticipant.celular.length > 0 &&
      dataParticipant.personType === 'INDIVIDUAL'
    ) {
      const parsedDate = parse(
        dataParticipant.birthDate,
        'yyyy-MM-dd',
        new Date()
      );

      const formattedDate = format(parsedDate, 'MM/dd/yyyy');

      const address = {
        zipCode: dataParticipant?.zipCode,
        street: dataParticipant?.street,
        district: dataParticipant?.district,
        number: addressNumber,
        state: dataParticipant?.state,
        city: dataParticipant?.city,
      };

      form.setFieldsValue({
        nome: dataParticipant.name,
        cpf: cpf.format(dataParticipant.documentNumber),
        dataNascimento: dayjs(formattedDate),
        ddd: dataParticipant.celular[0].ddd,
        celular: dataParticipant.celular[0].numero,
        email: dataParticipant.email,
        cep: dataParticipant.zipCode,
        rua: dataParticipant.street,
        complemento: dataParticipant.complement,
        bairro: dataParticipant.district,
        numero: addressNumber,
        estado: dataParticipant.state,
        cidade: dataParticipant.city,
        enderecoSelecionado: !hasNullOrUndefinedValues(address) ? 0 : 1,
      });

      if (!hasNullOrUndefinedValues(address)) {
        setEnderecoSelecionadoWatch(true);
        return;
      }
      form.resetFields([
        'cep',
        'rua',
        'bairro',
        'cidade',
        'complemento',
        'estado',
        'numero',
      ]);
      setEnderecoSelecionadoWatch(false);
      form.validateFields([
        'cep',
        'rua',
        'bairro',
        'cidade',
        'estado',
        'numero',
      ]);
    }

    if (
      dataParticipant &&
      dataParticipant.celular &&
      dataParticipant.celular.length > 0 &&
      dataParticipant.personType === 'COMPANY'
    ) {
      const address = {
        zipCode: dataParticipant?.zipCode,
        street: dataParticipant?.street,
        district: dataParticipant?.district,
        number: addressNumber,
        state: dataParticipant?.state,
        city: dataParticipant?.city,
      };

      form.setFieldsValue({
        razaoSocial: dataParticipant.name,
        cnpj: cnpj.format(dataParticipant.documentNumber),
        inscricaoEstadual: dataParticipant.ie,
        ddd: dataParticipant.celular[0].ddd,
        celular: dataParticipant.celular[0].numero,
        email: dataParticipant.email,
        cep: dataParticipant.zipCode,
        rua: dataParticipant.street,
        complemento: dataParticipant.complement,
        bairro: dataParticipant.district,
        numero: addressNumber,
        estado: dataParticipant.state,
        cidade: dataParticipant.city,
        enderecoSelecionado: !hasNullOrUndefinedValues(address) ? 0 : 1,
      });

      if (!hasNullOrUndefinedValues(address)) {
        setEnderecoSelecionadoWatch(true);
        return;
      }

      setEnderecoSelecionadoWatch(false);
      form.resetFields([
        'cep',
        'rua',
        'bairro',
        'cidade',
        'complemento',
        'estado',
        'numero',
      ]);
      form.validateFields([
        'cep',
        'rua',
        'bairro',
        'cidade',
        'estado',
        'numero',
      ]);
    }
  }, [
    dataParticipant.name,
    dataParticipant.documentNumber,
    dataParticipant.birthDate,
    dataParticipant.celular,
    dataParticipant.email,
    dataParticipant.city,
    dataParticipant.state,
    dataParticipant.district,
    dataParticipant.street,
    dataParticipant.number,
    dataParticipant.complement,
    dataParticipant.zipCode,
    dataParticipant.ie,
    dataParticipant.personType,
  ]);

  useEffect(() => {
    return () => {
      dispatch(setResetDataParticipant());
    };
  }, []);

  const uploadQuote = async (e) => {
    if (Array.isArray(e)) {
      return e;
    }

    const formData = new FormData();

    fileList.forEach((file) => {
      formData.append('file', file);
    });
    setUploading(true);

    fileList.forEach((file) => {
      formData.append('file', file);
    });

    try {
      const response = await redemptionsApiClient.post(
        '/RedemptionFile/Upload',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            ...config,
          },
        }
      );
      setQuoteUrl(response.data.url);
      message.success('Arquivo enviado com sucesso!');
    } catch (err) {
      console.info('uploadQuote err ::: ', err);
    } finally {
      setUploading(false);
    }
  };

  const yupSync = {
    async validator({ field }, value) {
      await schema.validateSyncAt(field, { [field]: value });
    },
  };
  const validateAddress = (spotRedemption) => {
    return !(
      spotRedemption.billingAddress.zipCode === '' ||
      spotRedemption.billingAddress.zipCode === '00000000' ||
      spotRedemption.billingAddress.zipCode === '00000-000' ||
      spotRedemption.billingAddress.address === '' ||
      spotRedemption.billingAddress.number === '' ||
      spotRedemption.billingAddress.neighborhood === '' ||
      spotRedemption.billingAddress.state === '' ||
      spotRedemption.billingAddress.city === '' ||
      spotRedemption.deliveryAddress.address === '' ||
      spotRedemption.deliveryAddress.number === '' ||
      spotRedemption.deliveryAddress.neighborhood === '' ||
      spotRedemption.deliveryAddress.zipCode === '' ||
      spotRedemption.deliveryAddress.state === '' ||
      spotRedemption.deliveryAddress.city === ''
    );
  };

  const handleValidateSpot = (spotRedemption) => {
    if (spotRedemption.participantId === 0) {
      return 400017;
    }
    // if (invalidPerson) {
    //   return 400021;
    // }

    if (!validateAddress(spotRedemption)) {
      return 400018;
    }

    if (!cotacaoPremmiar && spotRedemption.supplier.document.length === 0) {
      return 400022;
    }

    if (!cotacaoPremmiar && (quoteUrl === null || quoteUrl.length === 0)) {
      return 400023;
    }

    if (spotRedemption.products.length === 0) {
      return 400016;
    }

    return 0;
  };

  const handleSendRedemption = async (values) => {
    if (values.numero == 'S/N') values.numero = '0';
    if (values?.subEnderecoEntregaNumero == 'S/N')
      values.subEnderecoEntregaNumero = '0';

    if (
      (tipoSolicitacaoWatch != 3 && isEmpty(products)) ||
      (tipoSolicitacaoWatch == 3 &&
        isEmpty(hierarchyProductsLocalStorageValue?.products))
    ) {
      setTableProductIsEmpty(true);
      setBotaoValido(false);
      return;
    }

    let data = {
      participantId: Number(dataParticipant.id),
      participantInfos: {
        name:
          dataParticipant.personType === 'INDIVIDUAL'
            ? values.nome
            : values.razaoSocial,
        document:
          dataParticipant.personType === 'INDIVIDUAL'
            ? cpf.strip(values.cpf)
            : cnpj.strip(values.cnpj),
        birthdate:
          dataParticipant.personType === 'INDIVIDUAL'
            ? dayjs(values.dataNascimento).format('YYYY-MM-DD')
            : '',
        ie: values.inscricaoEstadual ?? null,
        ddd: values.ddd,
        phone: values.celular,
        email: values.email,
      },
      managerId:
        values.tipoSolicitacao.value === '1'
          ? null
          : isPMO || validGroup || isManager || isLead
          ? userProfile['custom:participant_id']
          : null,
      products:
        tipoSolicitacaoWatch == 3
          ? hierarchyProductsLocalStorageValue?.products?.map((item) => {
              return {
                sku: item.sku,
                name: item.name,
                description: item.description,
                quantity: Number(item.quantity),
                unitPrice: item.unitPrice,
                image: '',
                vendorId: item.vendorId.toString(),
                originalId: item.originalId,
                unitPoints: item.unitPrice,
              };
            })
          : products.map((item) => {
              let dataCategories = {
                categoryName: item.categoryName || null,
                categoryId: item.categoryId || null,
                subCategoryName: item.subCategoryName || null,
                subCategoryId: item.subCategoryId || null,
              };

              if (cotacaoPremmiar) {
                dataCategories = {
                  categoryName: null,
                  categoryId: null,
                  subCategoryName: null,
                  subCategoryId: null,
                };
              }

              return {
                uuid: uuidv4(),
                name: item.name,
                description: item.description,
                quantity: Number(item.quantity),
                unitPrice: item.unitPrice,
                image: '',
                vendorId: '',
                originalId: '',
                unitPoints: item.points,
                ...dataCategories,
              };
            }),
      supplier:
        fornecedorPreferenciaWatch == 1
          ? null
          : novoFornecedor
          ? {
              document: cnpj.strip(values.cnpjFornecedor),
              companyName: values.nomeFornecedor,
            }
          : {
              document: cnpj.isValid(values.buscaFornecedor)
                ? values.buscaFornecedor
                : cnpj.strip(dataBuscaFornecedor.cnpj),
              companyName: dataBuscaFornecedor.nomeEmpresa,
            },
      quote: quoteUrl,
      billingAddress: {
        address: values.rua,
        number: values.numero,
        complement: values.complemento,
        neighborhood: values.bairro,
        zipCode: String(values.cep).replace(/[^0-9]/g, ''),
        state: values.estado,
        city: values.cidade,
      },
      deliveryAddress:
        tipoSolicitacaoWatch != 3 && !values.showEnderecoFaturamento
          ? {
              address: values.subEnderecoEntregaRua,
              number: values.subEnderecoEntregaNumero,
              complement: values.subEnderecoEntregaComplemento,
              neighborhood: values.subEnderecoEntregaBairro,
              zipCode: String(values.subEnderecoEntregaCep).replace(
                /[^0-9]/g,
                ''
              ),
              state: values.subEnderecoEntregaEstado,
              city: values.subEnderecoEntregaCidade,
            }
          : {
              address: values.rua,
              number: values.numero,
              complement: values.complemento,
              neighborhood: values.bairro,
              zipCode: String(values.cep).replace(/[^0-9]/g, ''),
              state: values.estado,
              city: values.cidade,
            },

      forecastDate:
        values.dataLimiteProduto === '' ||
        values.dataLimiteProduto === 'Invalid Date' ||
        values.dataLimiteProduto == null
          ? null
          : dayjs(values.dataLimiteProduto).format('YYYY-MM-DD'),

      //HIERARQUIA
      type:
        tipoSolicitacaoWatch?.value === '1'
          ? Number(values.tipoSolicitacao.value)
          : Number(values.tipoSolicitacao),
      sendToOperation: cotacaoPremmiar,
      shippingValue: tipoSolicitacaoWatch
        ? hierarchyShipping.total
        : productsTotalShippingRate,
    };

    if (data.supplier?.document == '' || data.supplier?.companyName == '') {
      data = {
        ...data,
        supplier: null,
      };
    }

    const validateSpot = handleValidateSpot(data);

    if (validateSpot === 0) {
      let routeRedemptionType = '/Redemption/Spot';

      if (tipoSolicitacaoWatch == 3) {
        routeRedemptionType = '/Redemption/Hierarchy';
      }

      setLoadingSubmit(true);

      await redemptionsApiClient
        .post(routeRedemptionType, data, {
          headers: config,
        })
        .then((response) => {
          cleanSimulationData();
          navigate('/redemption-success', {
            state: {
              id: response.data.id,
            },
          });

          setLoadingSubmit(false);
        })
        .catch((err) => {
          message.error('Ocorreu um erro ao enviar a solicitação!' + err);
          setLoadingSubmit(false);
        });
    }
  };

  const breadcrumbMock = [
    {
      title: 'Início',
      path: '/',
    },
    {
      title: 'Nova Solicitação',
      path: '/spot-redemption',
    },
  ];
  const findNameOfParticipantSelectedForHierarchy = ({ maxNameSize }) => {
    const participantName = walletParticipant?.find(
      (item) => item.cpfCnpj === participanteWatch
    )?.name;

    if (participantName?.length > maxNameSize) {
      return participantName.substring(0, maxNameSize) + '...';
    } else {
      return participantName;
    }
  };

  const openParticipantCatalog = () => {
    const win = window.open('/', '_blank');
    win.focus();
  };

  const cleanSimulationData = () => {
    setSimulationLocalStorageValue({});
    setHierarchyLocalStorageValue({ products: [] });
  };

  return access ? (
    <UnauthorizedSpot />
  ) : (
    <VertContainer fluid className="newsolicitation-page">
      <VertContainer spacingX="regular" spacingY="small">
        <Row className="extract-page-breadcrumb" align="middle" gutter={6}>
          <Col span={24}>
            <VertBreadcrumb
              hasBackButton={true}
              separator={<VertIcon component={RightOutlined} />}
              items={breadcrumbMock}
            />
          </Col>
        </Row>
        <Form
          id="solicitation-form"
          onFinish={handleSendRedemption}
          form={form}
          initialValues={{
            tipoSolicitacao: simulationLocalStorageValue?.enabled ? '3' : '2',
            participante: simulationLocalStorageValue?.enabled
              ? simulationLocalStorageValue?.userName
              : '',
            nome: '',
            cpf: '',
            razaoSocial: '',
            cnpj: '',
            inscricaoEstadual: '',
            dataNascimento: '',
            ddd: '',
            celular: '',
            email: '',
            cep: '',
            rua: '',
            complemento: '',
            bairro: '',
            numero: '',
            estado: '',
            cidade: '',
            enderecoSelecionado: 1,
            showEnderecoFaturamento: true,
            subEnderecoEntregaCep: '',
            subEnderecoEntregaRua: '',
            subEnderecoEntregaComplemento: '',
            subEnderecoEntregaBairro: '',
            subEnderecoEntregaNumero: '',
            subEnderecoEntregaEstado: '',
            subEnderecoEntregaCidade: '',
            cotacaoPremmiar: true,
            dataLimiteProduto: '',
            fornecedorPreferencia: 0,
            buscaFornecedor: '',
            novoFornecedor: false,
            arquivoCotacao: '',
            nomeFornecedor: '',
            cnpjFornecedor: '',
            fileList: [],
          }}
        >
          <Row gutter={[16, 16]} justify="center" verticalSpacing="regular">
            <Col span={24}>
              <VertTypography.Title>Nova Solicitação</VertTypography.Title>
              <VertTypography.Paragraph>
                Faça um pedido de orçamento, preenchendo o formulário abaixo,
                que faremos o possível para enviar o produto escolhido.
              </VertTypography.Paragraph>
            </Col>
          </Row>
          {validateAccess() && (
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12}>
                <Row gutter={0} verticalSpacing="regular">
                  <VertTypography.Paragraph>
                    Tipo de Solicitação
                  </VertTypography.Paragraph>
                </Row>
                <Form.Item name="tipoSolicitacao" rules={[yupSync]}>
                  <VertSelect
                    label="Selecione o tipo de solicitação"
                    items={optionsRedemption()}
                    showSearch
                    onChange={(optionValue) => {
                      if (optionValue !== 3) {
                        cleanSimulationData();
                        form.setFieldValue('showEnderecoFaturamento', true);
                      } else {
                        form.setFieldValue('showEnderecoFaturamento', false);
                      }
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
          )}
          <Row gutter={[16, 16]} justify="start" wrap>
            <TitleForm icon={<UserOutlined />} title="Participante" />
          </Row>

          <Row
            gutter={[16, 16]}
            className={
              tipoSolicitacaoWatch?.value === '1' ? 'select-disabled-spot' : ''
            }
          >
            <Col xs={24} sm={12}>
              <Row gutter={0} verticalSpacing="regular">
                <VertTypography.Paragraph>
                  Participante (Nome)
                </VertTypography.Paragraph>
              </Row>

              <Form.Item name="participante" rules={[yupSync]}>
                <VertSelect
                  items={valuesParticipantName}
                  showSearch
                  loading={loading}
                  disabled={
                    loading ||
                    (tipoSolicitacaoWatch === '3' &&
                      simulationLocalStorageValue?.enabled)
                  }
                  onChange={handleParticipantChange}
                  allowClear={participanteWatch}
                  optionFilterProp="label"
                  filterOption={(input, option) => {
                    return (
                      option.label
                        ?.toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    );
                  }}
                  notFoundContent={
                    <VertTypography.Text>Sem resultados</VertTypography.Text>
                  }
                />
              </Form.Item>
            </Col>
          </Row>
          {participanteWatch && (
            <>
              <Row gutter={[16, 16]}>
                <Col xs={12} sm={12} md={6}>
                  <VertTypography.Paragraph>
                    Saldo do Participante
                  </VertTypography.Paragraph>

                  {loadingDataUserInfos ? (
                    <VertTypography.Text>Carregando...</VertTypography.Text>
                  ) : (
                    <VertTypography.Text>
                      {convertPoints(
                        simulationLocalStorageValue?.enabled
                          ? simulationLocalStorageValue?.balance
                          : saldoParticipante,
                        0
                      ) + ' pontos' || `0 pontos`}
                    </VertTypography.Text>
                  )}
                </Col>

                {validateAccess() && tipoSolicitacaoWatch !== '3' && (
                  <Col xs={12} sm={12} md={6}>
                    <VertTypography.Paragraph>
                      Subsegmento
                    </VertTypography.Paragraph>
                    <VertTypography.Title level={2}>
                      {loadingDataUserInfos ? (
                        <VertTypography.Title level={2}>
                          Carregando...
                        </VertTypography.Title>
                      ) : subSegmento ? (
                        <>
                          {subSegmento}
                          {!getGroups(
                            subSegmento,
                            Number(tipoSolicitacaoWatch)
                          ) && ` - Participante não elegível a 'Spot'`}
                        </>
                      ) : (
                        `-`
                      )}
                    </VertTypography.Title>
                  </Col>
                )}
              </Row>
              <Row
                gutter={[16, 16]}
                className="margin-top-small margin-bottom-small"
              >
                {validateAccess() &&
                  tipoSolicitacaoWatch == '3' &&
                  !loadingDataUserInfos &&
                  (!!simulationLocalStorageValue?.enabled ? (
                    <>
                      <Col xs={24} sm={24} md={24}>
                        <VertButton type="default">
                          <Typography.Text
                            onClick={() => setIsOpenFinishSimulationModal(true)}
                          >
                            ENCERRAR SIMULAÇÃO
                          </Typography.Text>
                        </VertButton>
                      </Col>
                      <Col xs={24} sm={24} md={24}>
                        <VertButton type="highlight">
                          <Typography.Text
                            onClick={() => openParticipantCatalog()}
                            style={{ color: 'var(--color-white)' }}
                          >
                            IR PARA O CATÁLOGO DO PARTICIPANTE
                          </Typography.Text>
                        </VertButton>
                      </Col>
                    </>
                  ) : (
                    <Col xs={24} sm={24} md={24} className="">
                      <VertButton type="highlight">
                        <Typography.Text
                          onClick={() => setIsOpenHierarchyModal(true)}
                          style={{ color: 'var(--color-white)' }}
                        >
                          {`ACESSAR CATÁLOGO POR ${findNameOfParticipantSelectedForHierarchy(
                            { maxNameSize: 15 }
                          )?.toUpperCase()}`}
                        </Typography.Text>
                      </VertButton>
                    </Col>
                  ))}
              </Row>
            </>
          )}
          {participanteWatch && (
            <Spin spinning={loadingDataUserInfos}>
              {dataParticipant.personType === 'INDIVIDUAL' ? (
                <>
                  <Row gutter={[16, 16]} className="margin-top-small">
                    <Col xs={24} sm={12}>
                      <Form.Item name="nome" rules={[yupSync]}>
                        <VertInput label="Nome" />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]}>
                    <Col xs={12} sm={12} md={6}>
                      <Form.Item name="cpf" rules={[yupSync]}>
                        <MaskedInput mask="999.999.999-99" label="CPF" />
                      </Form.Item>
                    </Col>
                    <Col xs={12} sm={12} md={6}>
                      <Form.Item
                        name="dataNascimento"
                        rules={[
                          {
                            required: true,
                            message: 'Data de Nascimento é obrigatório',
                          },
                        ]}
                      >
                        <VertDatePicker
                          picker="date"
                          popupClassName="spot-page-datepicker"
                          format="DD/MM/YYYY"
                          label="Data de Nascimento"
                          placement="bottomLeft"
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12}>
                      <Form.Item name="razaoSocial" rules={[yupSync]}>
                        <VertInput label="Razão Social" />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]}>
                    <Col xs={12} sm={12} md={6}>
                      <Form.Item name="cnpj" rules={[yupSync]}>
                        <MaskedInput mask="99.999.999/9999-99" label="CNPJ" />
                      </Form.Item>
                    </Col>
                    <Col xs={12} sm={12} md={6}>
                      <Form.Item name="inscricaoEstadual" rules={[yupSync]}>
                        <VertInput label="Inscrição Estadual" />
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              )}

              <Row gutter={[16, 16]}>
                <Col xs={12} sm={3} md={2}>
                  <Form.Item name="ddd" rules={[yupSync]}>
                    <VertInput label="DDD" maxLength={2} />
                  </Form.Item>
                </Col>
                <Col xs={12} sm={6} md={4}>
                  <Form.Item name="celular" rules={[yupSync]}>
                    <MaskedInput mask="99999-9999" label="Celular" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <Form.Item name="email" rules={[yupSync]}>
                    <VertInput label="E-mail" />
                  </Form.Item>
                </Col>
              </Row>
            </Spin>
          )}
          {tipoSolicitacaoWatch === '3' && (
            <>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12}>
                  <TitleForm icon={<LuTruck />} title="Endereço de Entrega" />
                  <VertTypography.Paragraph type="default">
                    Aonde deseja que seu pedido seja entregue?
                  </VertTypography.Paragraph>

                  <Spin spinning={loadingCep || loadingDataUserInfos}>
                    <Form.Item name="cep" rules={[yupSync]}>
                      <MaskedInput
                        mask="99999-999"
                        label="CEP"
                        onChange={(e) => {
                          const value = e.replace(/[^0-9]/g, '');

                          if (value.length === 8) {
                            fetchCep(value, 'cep');
                          }
                        }}
                      />
                    </Form.Item>

                    <Row gutter={[16, 16]} verticalSpacing="small">
                      <Col xs={24} sm={12}>
                        <Form.Item name="rua" rules={[yupSync]}>
                          <VertInput label="Rua" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12}>
                        <Form.Item name="numero" rules={[yupSync]}>
                          <VertInput
                            label="Número"
                            maxLength={20}
                            disabled={numeroEndereco === 'S/N'}
                          />
                        </Form.Item>
                        <VertCheckbox
                          onClick={() => {
                            if (form.getFieldValue('numero') === '') {
                              form.setFieldsValue({
                                numero: 'S/N',
                              });
                            } else if (
                              form.getFieldValue('numero') !== 'S/N' &&
                              form.getFieldValue('numero') !== ''
                            ) {
                              form.setFieldsValue({
                                numero: 'S/N',
                              });
                            } else {
                              form.setFieldsValue({
                                numero: '',
                              });
                            }
                          }}
                          checked={numeroEndereco === 'S/N'}
                        >
                          Sem número
                        </VertCheckbox>
                      </Col>
                    </Row>

                    <Form.Item name="complemento" rules={[yupSync]}>
                      <VertInput label="Complemento" />
                    </Form.Item>
                    <Row gutter={[16, 16]}>
                      <Col xs={24} sm={12}>
                        <Form.Item name="bairro" rules={[yupSync]}>
                          <VertInput label="Bairro" />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12}>
                        <Form.Item name="estado" rules={[yupSync]}>
                          <VertInput label="Estado" />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Form.Item name="cidade" rules={[yupSync]}>
                      <VertInput label="Cidade" />
                    </Form.Item>
                  </Spin>
                </Col>
              </Row>
            </>
          )}
          {tipoSolicitacaoWatch !== '3' && (
            <>
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12}>
                  <TitleForm
                    icon={<CreditCardOutlined />}
                    title="Endereço de Faturamento"
                  />
                  <VertTypography.Paragraph>
                    Qual será o endereço de faturamento?
                  </VertTypography.Paragraph>

                  <Row gutter={[16, 16]}>
                    <Form.Item name="enderecoSelecionado">
                      <VertRadio.Group
                        buttonStyle="solid"
                        size="small"
                        template="marketplace"
                        onChange={(e) => {
                          if (e.target.value === 1) {
                            form.resetFields([
                              'cep',
                              'rua',
                              'complemento',
                              'bairro',
                              'numero',
                              'estado',
                              'cidade',
                            ]);
                            setEnderecoSelecionadoWatch(false);
                          } else {
                            form.setFieldsValue({
                              cep: dataParticipant.zipCode,
                              rua: dataParticipant.street,
                              complemento: dataParticipant.complement,
                              bairro: dataParticipant.district,
                              numero: dataParticipant.number,
                              estado: dataParticipant.state,
                              cidade: dataParticipant.city,
                            });
                            setEnderecoSelecionadoWatch(true);
                          }
                        }}
                      >
                        <VertRadio value={0} template="marketplace">
                          Endereço do Cadastro
                        </VertRadio>
                        <VertRadio template="marketplace" value={1}>
                          Outro Endereço
                        </VertRadio>
                      </VertRadio.Group>
                    </Form.Item>
                  </Row>
                  <Spin spinning={loadingCep || loadingDataUserInfos}>
                    <Form.Item name="cep" rules={[yupSync]}>
                      <MaskedInput
                        mask="99999-999"
                        label="CEP"
                        onChange={(e) => {
                          const value = e.replace(/[^0-9]/g, '');

                          if (value.length === 8) {
                            fetchCep(value, 'cep');
                          }
                        }}
                        disabled={enderecoSelecionadoWatch}
                      />
                    </Form.Item>

                    <Row gutter={[16, 16]} verticalSpacing="small">
                      <Col xs={24} sm={12}>
                        <Form.Item name="rua" rules={[yupSync]}>
                          <VertInput
                            label="Rua"
                            disabled={enderecoSelecionadoWatch}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} sm={12}>
                        <Form.Item name="numero" rules={[yupSync]}>
                          <VertInput
                            label="Número"
                            disabled={
                              enderecoSelecionadoWatch ||
                              numeroEndereco === 'S/N'
                            }
                            maxLength={20}
                          />
                        </Form.Item>
                        <VertCheckbox
                          onClick={() => {
                            if (form.getFieldValue('numero') === '') {
                              form.setFieldsValue({
                                numero: 'S/N',
                              });
                            } else if (
                              form.getFieldValue('numero') !== 'S/N' &&
                              form.getFieldValue('numero') !== ''
                            ) {
                              form.setFieldsValue({
                                numero: 'S/N',
                              });
                            } else {
                              form.setFieldsValue({
                                numero: '',
                              });
                            }
                          }}
                          checked={numeroEndereco === 'S/N'}
                          disabled={enderecoSelecionadoWatch}
                        >
                          Sem número
                        </VertCheckbox>
                      </Col>
                    </Row>

                    <Form.Item name="complemento" rules={[yupSync]}>
                      <VertInput
                        label="Complemento"
                        disabled={enderecoSelecionadoWatch}
                      />
                    </Form.Item>
                    <Row gutter={[16, 16]}>
                      <Col xs={24} sm={12}>
                        <Form.Item name="bairro" rules={[yupSync]}>
                          <VertInput
                            label="Bairro"
                            disabled={enderecoSelecionadoWatch}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12}>
                        <Form.Item name="estado" rules={[yupSync]}>
                          <VertInput
                            label="Estado"
                            disabled={enderecoSelecionadoWatch}
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Form.Item name="cidade" rules={[yupSync]}>
                      <VertInput
                        label="Cidade"
                        disabled={enderecoSelecionadoWatch}
                      />
                    </Form.Item>
                  </Spin>
                </Col>

                <Col xs={24} sm={12}>
                  <TitleForm
                    icon={<EnvironmentOutlined />}
                    title="Endereço de Entrega"
                  />
                  <VertTypography.Paragraph>
                    Onde deseja que seu pedido seja entregue?
                  </VertTypography.Paragraph>
                  <div className="box-show-endereco-entrega-spot">
                    <Form.Item name="showEnderecoFaturamento">
                      <VertCheckbox
                        name="showEnderecoFaturamento"
                        defaultChecked={true}
                        onChange={(e) => {
                          form.setFieldValue(
                            'showEnderecoFaturamento',
                            e.target.checked
                          );
                        }}
                        value={form.getFieldValue('showEnderecoFaturamento')}
                      >
                        O endereço de Entrega é o mesmo do Faturamento.
                      </VertCheckbox>
                    </Form.Item>
                  </div>

                  {!showEnderecoFaturamentoWatch && (
                    <>
                      <Spin spinning={loadingSubEnderecoEntregaCep}>
                        <Form.Item
                          name="subEnderecoEntregaCep"
                          rules={[yupSync]}
                        >
                          <MaskedInput
                            mask="99999-999"
                            label="CEP"
                            onChange={(e) => {
                              const value = e.replace(/[^0-9]/g, '');

                              if (value.length === 8) {
                                fetchCep(value, 'subEnderecoEntregaCep');
                              }
                            }}
                          />
                        </Form.Item>

                        <Row gutter={[16, 16]} verticalSpacing="small">
                          <Col xs={24} sm={12}>
                            <Form.Item
                              name="subEnderecoEntregaRua"
                              rules={[yupSync]}
                            >
                              <VertInput label="Rua" />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12}>
                            <Form.Item
                              name="subEnderecoEntregaNumero"
                              rules={[yupSync]}
                            >
                              <VertInput
                                label="Número"
                                maxLength={20}
                                disabled={subEnderecoEntregaNumero === 'S/N'}
                              />
                            </Form.Item>
                            <VertCheckbox
                              onClick={() => {
                                if (
                                  form.getFieldValue(
                                    'subEnderecoEntregaNumero'
                                  ) === ''
                                ) {
                                  form.setFieldsValue({
                                    subEnderecoEntregaNumero: 'S/N',
                                  });
                                } else if (
                                  form.getFieldValue(
                                    'subEnderecoEntregaNumero'
                                  ) !== 'S/N' &&
                                  form.getFieldValue(
                                    'subEnderecoEntregaNumero'
                                  ) !== ''
                                ) {
                                  form.setFieldsValue({
                                    subEnderecoEntregaNumero: 'S/N',
                                  });
                                } else {
                                  form.setFieldsValue({
                                    subEnderecoEntregaNumero: '',
                                  });
                                }
                              }}
                              checked={subEnderecoEntregaNumero === 'S/N'}
                            >
                              Sem número
                            </VertCheckbox>
                          </Col>
                        </Row>

                        <Form.Item
                          name="subEnderecoEntregaComplemento"
                          rules={[yupSync]}
                        >
                          <VertInput label="Complemento" />
                        </Form.Item>
                        <Row gutter={[16, 16]}>
                          <Col xs={24} sm={12}>
                            <Form.Item
                              name="subEnderecoEntregaBairro"
                              rules={[yupSync]}
                            >
                              <VertInput label="Bairro" />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12}>
                            <Form.Item
                              name="subEnderecoEntregaEstado"
                              rules={[yupSync]}
                            >
                              <VertInput label="Estado" />
                            </Form.Item>
                          </Col>
                        </Row>

                        <Form.Item
                          name="subEnderecoEntregaCidade"
                          rules={[yupSync]}
                        >
                          <VertInput label="Cidade" />
                        </Form.Item>
                      </Spin>
                    </>
                  )}
                </Col>
              </Row>
              {tipoSolicitacaoWatch === '2' && (
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={12}>
                    <VertTypography.Paragraph>
                      Você tem uma data limite para receber este produto?
                    </VertTypography.Paragraph>

                    <Form.Item
                      name="dataLimiteProduto"
                      rules={[
                        {
                          validator: async (_, value) => {
                            if (!value) {
                              return Promise.resolve();
                            }
                            const currentDate = new Date();
                            currentDate.setHours(0, 0, 0, 0);

                            const selectedDate = new Date(value);
                            selectedDate.setHours(0, 0, 0, 0);

                            if (selectedDate < currentDate) {
                              return Promise.reject(
                                new Error(
                                  'A data não pode ser anterior à data atual!'
                                )
                              );
                            }
                          },
                        },
                      ]}
                    >
                      <VertDatePicker
                        picker="date"
                        format="DD/MM/YYYY"
                        popupClassName="spot-page-datepicker"
                        placement="bottomLeft"
                      />
                    </Form.Item>
                  </Col>
                </Row>
              )}
            </>
          )}
          {tipoSolicitacaoWatch !== '3' && (
            <>
              <Row align="middle" gutter={[16, 16]}>
                <TitleForm icon={<ShopOutlined />} title="Fornecedor" />
              </Row>
              <Row gutter={[16, 16]}>
                {cotacaoPremmiar ? (
                  <Col xs={24} sm={12}>
                    <VertTypography.Paragraph>
                      Possui fornecedor de preferência?
                    </VertTypography.Paragraph>
                    <Form.Item name="fornecedorPreferencia">
                      <VertRadio.Group
                        onChange={(e) => {
                          setFornecedorPreferenciaWatch(e.target.value);
                        }}
                      >
                        <VertRadio value={0}>Sim</VertRadio>
                        <VertRadio value={1}> Não </VertRadio>
                      </VertRadio.Group>
                    </Form.Item>
                  </Col>
                ) : (
                  <Col xs={24} sm={12}>
                    <Typography.Title level={3}>
                      Obrigatório a seleção de um fornecedor existente e envio
                      de arquivo de cotação.
                    </Typography.Title>
                  </Col>
                )}
              </Row>
              {fornecedorPreferenciaWatch === 0 && (
                <>
                  {' '}
                  <Row gutter={[16, 16]}>
                    <Col xs={24} sm={24} md={12}>
                      <Row gutter={0} verticalSpacing="regular">
                        <VertTypography.Paragraph>
                          Busca pelo Nome ou CNPJ
                        </VertTypography.Paragraph>
                      </Row>
                      <Form.Item
                        name="buscaFornecedor"
                        rules={[
                          {
                            required: !cotacaoPremmiar,
                            message:
                              'Por favor, selecione um fornecedor existente.',
                          },
                        ]}
                      >
                        <VertSelect
                          popupClassName="spot-page-select-fornecedor"
                          items={dataSearchFornecedor}
                          showSearch
                          allowClear
                          disabled={novoFornecedor}
                          filterOption={(input, option) => {
                            return (
                              option.label
                                ?.toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            );
                          }}
                          onSearch={(e) => {
                            if (cnpj.isValid(e)) {
                              fetchFornecedor(cnpj.strip(e));
                              setBuscaFornecedorWatch(cnpj.strip(e));
                            } else {
                              fetchFornecedor(e);
                              setBuscaFornecedorWatch(e);
                            }
                          }}
                          onChange={(e) => {
                            if (cnpj.isValid(e)) {
                              setDataBuscaFornecedor({
                                cnpj: e,
                                nomeEmpresa: dataSearchFornecedor
                                  .find((item) => item.value === e)
                                  .label.split(' - ')[0],
                              });
                            } else {
                              setDataBuscaFornecedor({
                                cnpj: dataFornecedor.find(
                                  (item) => item.companyName === e
                                )?.document,

                                nomeEmpresa: e,
                              });
                            }
                          }}
                          dropdownRender={(menu) => (
                            <>
                              {dataSearchFornecedor.length === 0 ? (
                                <div className="vert-select-fornecedor">
                                  {isEmpty(buscaFornecedorValue) ||
                                  !cotacaoPremmiar ? (
                                    <VertTypography.Text type="default">
                                      Sem resultados
                                    </VertTypography.Text>
                                  ) : (
                                    cotacaoPremmiar && (
                                      <VertTypography.Text
                                        type="detached"
                                        onClick={() => {
                                          setNovoFornecedor(true);
                                          form.setFieldValue(
                                            'buscaFornecedor',
                                            buscaFornecedorValue
                                          );

                                          if (
                                            cnpj.isValid(buscaFornecedorValue)
                                          ) {
                                            form.setFieldsValue({
                                              cnpjFornecedor:
                                                buscaFornecedorValue,
                                            });
                                          } else {
                                            form.setFieldsValue({
                                              nomeFornecedor:
                                                buscaFornecedorValue,
                                            });
                                          }
                                        }}
                                      >
                                        {`Criar novo fornecedor: ${buscaFornecedorValue}`}
                                      </VertTypography.Text>
                                    )
                                  )}
                                </div>
                              ) : (
                                menu
                              )}
                            </>
                          )}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  {!novoFornecedor &&
                    dataBuscaFornecedor.cnpj &&
                    dataBuscaFornecedor.nomeEmpresa && (
                      <Row gutter={[16, 16]} verticalSpacing="regular">
                        <Col xs={24} sm={12}>
                          <VertTypography.Paragraph>
                            Nome do Fornecedor
                          </VertTypography.Paragraph>
                          <VertTypography.Title level={2}>
                            {mediaQuery
                              ? dataFornecedor.find(
                                  (cnpj) =>
                                    cnpj.document === dataBuscaFornecedor.cnpj
                                )?.companyName
                              : dataBuscaFornecedor.nomeEmpresa}
                          </VertTypography.Title>
                        </Col>
                        <Col xs={24} sm={12}>
                          <VertTypography.Paragraph>
                            Documento
                          </VertTypography.Paragraph>
                          <VertTypography.Title level={2}>
                            {cnpj.format(dataBuscaFornecedor.cnpj)}
                          </VertTypography.Title>
                        </Col>
                      </Row>
                    )}
                  {novoFornecedor && cotacaoPremmiar && (
                    <>
                      <div className="div-button-fornecedor-spot">
                        <VertButton
                          block
                          size="small"
                          onClick={() => {
                            setNovoFornecedor(false);
                            form.resetFields([
                              'nomeFornecedor',
                              'cnpjFornecedor',
                              'buscaFornecedor',
                            ]);
                            setDataBuscaFornecedor({
                              cnpj: '',
                              nomeEmpresa: '',
                            });
                          }}
                          icon={<CloseOutlined />}
                        />
                      </div>
                      <Row gutter={[16, 16]}>
                        <Col xs={24} sm={12}>
                          <Form.Item name="nomeFornecedor" rules={[yupSync]}>
                            <VertInput label="Nome do Fornecedor" />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={12}>
                          <Form.Item name="cnpjFornecedor" rules={[yupSync]}>
                            <MaskedInput
                              label="CNPJ"
                              mask="99.999.999/9999-99"
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </>
                  )}
                  <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12}>
                      <VertTypography.Paragraph>
                        {!cotacaoPremmiar
                          ? 'Selecione o arquivo de cotação'
                          : 'Você possui alguma cotação? (Se sim, insira o arquivo abaixo)'}
                      </VertTypography.Paragraph>
                      <Form.Item
                        name="fileList"
                        valuePropName="fileList"
                        rules={[
                          {
                            required: !cotacaoPremmiar,
                            message:
                              'É necessário enviar um arquivo de cotação.',
                          },
                        ]}
                        getValueFromEvent={(e) => {
                          uploadQuote(e);
                          return e && e.fileList;
                        }}
                      >
                        <Upload
                          maxCount={1}
                          listType="picture"
                          beforeUpload={(file) => {
                            form.setFieldValue('fileList', [file]);
                            return false; // Evita o envio automático do arquivo
                          }}
                        >
                          <VertButton shape="default">Procurar</VertButton>
                        </Upload>
                      </Form.Item>
                    </Col>
                  </Row>
                  {validateAccess() && tipoSolicitacaoWatch?.value !== '1' && (
                    <Row gutter={[16, 16]}>
                      <Col xs={24} sm={12}>
                        <Form.Item name="cotacaoPremmiar">
                          <VertCheckbox
                            name="cotacaoPremmiar"
                            defaultChecked={true}
                            onChange={(e) => {
                              setCotacaoPremmiar(e.target.checked);
                            }}
                          >
                            Deseja cotação da Premmiar
                          </VertCheckbox>
                        </Form.Item>
                      </Col>
                    </Row>
                  )}
                </>
              )}
            </>
          )}
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12}>
              <Row align="middle" gutter={[16, 16]}>
                <TitleForm icon={<ShoppingCartOutlined />} title="Produto" />
              </Row>
            </Col>

            {tipoSolicitacaoWatch?.value == '1' ||
            tipoSolicitacaoWatch == '2' ? (
              <SpotTableAndProducts
                products={products}
                setProducts={setProducts}
                config={config}
                cotacaoPremmiar={cotacaoPremmiar}
                tipoSolicitacaoWatch={tipoSolicitacaoWatch}
              />
            ) : (
              <>
                {tipoSolicitacaoWatch == '3' &&
                hierarchyProductsLocalStorageValue?.products?.length ? (
                  <TableProductHierarchy
                    products={hierarchyProductsLocalStorageValue?.products}
                    typeRedemption={Number(tipoSolicitacaoWatch)}
                    validateAccess={validateAccess()}
                    undeliveredProducts={
                      hierarchyShipping?.undeliveredProducts || []
                    }
                  />
                ) : tableProductIsEmpty ||
                  !hierarchyProductsLocalStorageValue?.length ? (
                  <div className="box-product-spot">
                    <Typography.Paragraph type="danger">
                      Por favor, adicione ao menos 1 (um) produto para dar
                      continuidade à solicitação.
                    </Typography.Paragraph>
                  </div>
                ) : (
                  <div className="box-product-spot">
                    <VertTypography.Paragraph>
                      Não há informações a serem exibidas!
                    </VertTypography.Paragraph>
                  </div>
                )}
                {!!(
                  (tipoSolicitacaoWatch == 3 &&
                    hierarchyShipping &&
                    hierarchyShipping?.total) ||
                  (tipoSolicitacaoWatch == 3 && hierarchyShipping?.total == 0)
                ) && (
                  <>
                    <div className="box-value-hierarchy">
                      <Row
                        className="col-12"
                        style={{ display: 'flex', alignItems: 'center' }}
                      >
                        <Col lg={12} md={12} sm={24} xs={24}>
                          <VertTypography.Paragraph>
                            VALOR DOS PRODUTOS
                          </VertTypography.Paragraph>
                        </Col>
                        <Col
                          lg={12}
                          md={12}
                          sm={24}
                          xs={24}
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-end',
                          }}
                        >
                          {tipoSolicitacaoWatch == 3 ? (
                            <Typography.Text
                              style={{
                                fontSize: mediaQuery ? '12px' : '14px',
                                fontWeight: 'bold',
                              }}
                            >
                              {convertPoints(
                                hierarchyProductsLocalStorageValue.products.reduce(
                                  (accumulator, item) => {
                                    return (
                                      accumulator +
                                      item.unitPrice * item.quantity
                                    );
                                  },
                                  0
                                ),
                                0
                              )}{' '}
                              pontos
                            </Typography.Text>
                          ) : (
                            <>
                              <VertTypography.Paragraph>
                                {new Intl.NumberFormat('pt-BR', {
                                  style: 'currency',
                                  currency: 'BRL',
                                }).format(valorTotalProdutos)}
                              </VertTypography.Paragraph>
                              <ValuePriceForPoint price={valorTotalProdutos} />
                            </>
                          )}
                        </Col>
                      </Row>
                    </div>
                    {!!(
                      hierarchyProductsLocalStorageValue?.products?.length &&
                      hierarchyShipping?.undeliveredProducts &&
                      hierarchyShipping?.undeliveredProducts?.length == 0
                    ) && (
                      <div className="box-value-hierarchy">
                        <Row
                          className="col-12"
                          style={{ display: 'flex', alignItems: 'center' }}
                        >
                          <Col lg={12} md={12} sm={24} xs={24}>
                            <VertTypography.Paragraph>
                              VALOR DO FRETE
                            </VertTypography.Paragraph>
                          </Col>
                          <Col
                            className="shipping-value"
                            lg={12}
                            md={12}
                            sm={24}
                            xs={24}
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'flex-end',
                            }}
                          >
                            {hierarchyShipping.total > 0 ? (
                              <Typography.Text
                                style={{
                                  fontSize: mediaQuery ? '12px' : '14px',
                                  fontWeight: 'bold',
                                }}
                              >
                                {convertPoints(hierarchyShipping.total, 2) +
                                  ' pontos'}
                              </Typography.Text>
                            ) : (
                              <Typography.Text
                                className="free"
                                style={{
                                  fontSize: mediaQuery ? '12px' : '14px',
                                  fontWeight: 'bold',
                                }}
                              >
                                Grátis
                              </Typography.Text>
                            )}
                          </Col>
                        </Row>
                      </div>
                    )}
                    {hierarchyShipping.undeliveredProducts?.length > 0 && (
                      <VertContainer>
                        <Typography.Text type="danger">
                          Há produtos que não podem ser entregues para esse
                          participante
                        </Typography.Text>
                      </VertContainer>
                    )}
                  </>
                )}
                <div className="box-value-hierarchy">
                  <Row
                    className="col-12"
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    <Col
                      lg={12}
                      md={12}
                      sm={24}
                      xs={24}
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <VertTypography.Paragraph>
                        VALOR TOTAL
                      </VertTypography.Paragraph>
                      {insufficientPoints && (
                        <Typography.Paragraph type="danger">
                          {`Valor total ultrapassa o saldo disponível do participante: ${convertPoints(
                            saldoParticipante,
                            2
                          )} pontos`}
                        </Typography.Paragraph>
                      )}
                    </Col>
                    <Col
                      lg={12}
                      md={12}
                      sm={24}
                      xs={24}
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-end',
                      }}
                    >
                      {tipoSolicitacaoWatch != 3 ? (
                        <>
                          <VertTypography.Title level={2}>
                            {new Intl.NumberFormat('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                            }).format(valorTotalProdutos)}
                          </VertTypography.Title>
                          <ValuePriceForPoint price={valorTotalProdutos} />
                        </>
                      ) : (
                        <Typography.Text
                          style={{
                            fontSize: mediaQuery ? '12px' : '14px',
                            fontWeight: 'bold',
                          }}
                        >
                          {convertPoints(
                            hierarchyProductsLocalStorageValue.products.reduce(
                              (accumulator, item) => {
                                const unitPrice = item.unitPrice || 0;
                                const quantity = item.quantity || 0;
                                return accumulator + unitPrice * quantity;
                              },
                              0
                            ) + (hierarchyShipping.total || 0),
                            0
                          )}{' '}
                          pontos
                        </Typography.Text>
                      )}
                    </Col>
                  </Row>
                </div>
              </>
            )}

            <Col xs={24} className="box-buttons-spot-submit">
              <VertButton
                disabled={isFocalizationAnalyst}
                onClick={() => {
                  navigate('/list-redemptions');
                }}
                shape="default"
              >
                Ver Solicitações
              </VertButton>

              {hierarchyShipping?.undeliveredProducts?.length > 0 &&
              tipoSolicitacaoWatch != 3 ? (
                <VertTooltip title="Há produtos que não podem ser entregues para esse participante">
                  <VertButton
                    form="solicitation-form"
                    disabled={
                      !hierarchyProductsLocalStorageValue?.products?.length ||
                      hierarchyShipping?.undeliveredProducts?.length > 0 ||
                      !botaoValido
                    }
                    shape="default"
                    type="highlight"
                    htmlType="submit"
                    loading={loadingSubmit}
                  >
                    Enviar Solicitação
                  </VertButton>
                </VertTooltip>
              ) : (
                <VertButton
                  form="solicitation-form"
                  disabled={
                    tipoSolicitacaoWatch == 3
                      ? !hierarchyProductsLocalStorageValue?.products?.length
                      : !botaoValido ||
                        products?.length === 0 ||
                        isRequiredCategories
                  }
                  shape="default"
                  type="highlight"
                  htmlType="submit"
                  loading={loadingSubmit}
                >
                  Enviar Solicitação
                </VertButton>
              )}
            </Col>
          </Row>
        </Form>
      </VertContainer>
      <NewSolicitationModal cotacaoPremmiar={cotacaoPremmiar} />
      <OpenParticipantCatalogModal
        isOpen={isOpenHierarchyModal}
        onClose={() => setIsOpenHierarchyModal(false)}
        participantDocumentNumber={participanteWatch}
      />
      <FinishSimulationModal
        isOpen={isOpenFinishSimulationModal}
        onClose={() => setIsOpenFinishSimulationModal(false)}
      />
    </VertContainer>
  );
};

export default NewSolicitation;
